import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../constants/general-constants";
import {GREY_FONT} from "../constants/general-constants";
import {CSSTransition} from 'react-transition-group';
import './floorrowpercentageslider.css';
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import {functions} from "../constants/common-functions";
import FloorRowIcon from "../components/FloorRowIcon";
import {colorFunctions} from "../constants/colors";
import FloorRowSpaceTypePercentage from "../components/FloorRowSpaceTypePercentage";

export default function FloorRowPercentage({displayType, spaceTypeId, floorId, floorName, name, area, width, color, isFirst, isLast}){
	
	const [posLeft, setPosLeft] = useState("0px");
	const [posTop, setPosTop] = useState("0px");
	const [displayPopUp, setDisplayPopUp] = useState("none");
	const [thisBorderTopLeftRadius, setThisBorderTopLeftRadius] = useState("0");
	const [thisBorderTopRightRadius, setThisBorderTopRightRadius] = useState("0");
	const [thisBorderBottomLeftRadius, setThisBorderBottomLeftRadius] = useState("0");
	const [thisBorderBottomRightRadius, setThisBorderBottomRightRadius] = useState("0");
	const [displaySlider, setDisplaySlider] = useState(false);
	const [spaceTypes, setSpaceTypes] = useState([]);
	const [classificationItems, setClassificationItems] = useState([]);
	const [rooms, setRooms] = useState([]);
	
	const thisRef = useRef(null);
	
	useEffect(() => {
		setPosLeft(thisRef.current.getBoundingClientRect().left);
		
		
		if(isFirst === true){
			setThisBorderTopLeftRadius("5px");
			setThisBorderBottomLeftRadius("5px");
		}
		
		if(isLast === true){
			setThisBorderTopRightRadius("5px");
			setThisBorderBottomRightRadius("5px");
		}
		
	}, [floorId, spaceTypeId, width]);
	
	const getColorForSpaceType = (spaceTypeId) => {
		let returnIndex = 0;
		for(let i=0; i<spaceTypes.length; i++){
			if(spaceTypes[i].id === spaceTypeId){
				returnIndex = i;
			}
		}
		return colorFunctions.generateColorForIndex(returnIndex);
	};
	
	const getColorForClassificationItem = (classificationItemId) => {
		let returnIndex = 0;
		for(let i=0; i<classificationItems.length; i++){
			if(classificationItems[i].id === classificationItemId){
				returnIndex = i;
			}
		}
		return colorFunctions.generateColorForIndex(returnIndex);
	};
	
	const populateSpaceTypes = (input) => {
		let tempSpaceTypes = [];
		for(let i=0; i<input.length; i++){
			let isFirst = false;
			let isLast = false;
			
			if(i === 0){
				isFirst = true;
			}
			
			if(i === input.length - 1){
				isLast=true;
			}
			
			let areaPercentage = Math.round(100*input[i].value/area);
			tempSpaceTypes.push({
				id:input[i].id,
				name:input[i].code + ': ' + input[i].name,
				area:input[i].value,
				areaPercentage:areaPercentage,
				color:colorFunctions.generateColorForIndex(i),
				isFirst:isFirst,
				isLast:isLast
			});
		}
		
		setSpaceTypes(tempSpaceTypes);
	};
	
	const thisContainer = {
		display:"flex",
		width:width,
		height:"10px",
		cursor:"pointer",
		backgroundColor:color,
		borderBottomLeftRadius:thisBorderBottomLeftRadius,
		borderTopLeftRadius:thisBorderTopLeftRadius,
		borderBottomRightRadius:thisBorderBottomRightRadius,
		borderTopRightRadius:thisBorderTopRightRadius
	};
	
	const handleMouseOver = () => {
		setPosTop(thisRef.current.getBoundingClientRect().top - 20 + thisRef.current.scrollTop);
		setDisplayPopUp("flex");
	};
	
	const handleMouseLeave = () => {
		setDisplayPopUp("none");
	};
	
	const popUp = {
		display:displayPopUp,
		position:"fixed",
		left:posLeft,
		top:posTop,
		height:"40px",
		width:"300px",
		justifyContent:"space-between",
		borderRadius:"20px",
		alignItems:"center",
		backgroundColor:color
	};
	
	const popUpLabel = {
		display:"flex",
		paddingLeft:"10px",
		color:"white",
		fontSize:"14px"
	};
	
	const popUpIcon = {
		display:"flex",
		width:"30px",
		height:"30px",
		color:"white",
		margin:"10px"
	};
	
	const handleClick = () => {
		setDisplaySlider(true);
		setDisplayPopUp("none");
		functions.getArrayFromAjax("/resolutionsoftwareplatform/spacegettotalareabyspacetypeforfloorandspacetype?floorId=" + floorId + "&spaceTypeId=" + spaceTypeId, null, populateSpaceTypes);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/spacegetspacesforfloor?floorId=" + floorId + "&spaceTypeId=" + spaceTypeId, null, populateRooms);
		
	};
	
	const handleClose = () => {
		setDisplaySlider(false);
		setDisplayPopUp("none");
	};
	
	const roomListHeader = {
		display:"flex",
		width:"100%",
		height:"50px",
		alignItems:"center",
		justifyContent:"space-between"
	};
	
	const roomListTitle = {
		display:"flex",
		paddingLeft:"10px",
		fontSize:"16px",
		color:"black"
	};
	
	const closeArrowHolder = {
		display:"flex",
		marginRight:"10px",
		width:"30px",
		height:"30px",
		borderRadius:"15px",
		alignItems:"center",
		justifyContent:"space-around",
		cursor:"pointer",
		backgroundColor:COLOR_GRAY_BANNER_BACKGROUND
	};
	
	const closeArrowIcon = {
		display:"flex",
		width:"20px",
		height:"20px",
		color:"white"
	};
	
	const blankFunction = () => {
			
	};
	
	const buttons = [
		{icon:"camera", clickFunction:blankFunction},
		{icon:"file", clickFunction:blankFunction},
		{icon:"map", clickFunction:blankFunction}
	];
	
	const buttonDisplay = buttons.map((item, index) =>
		<FloorRowIcon
			id={index}
			clickFunction={item.clickFunction}
			icon={item.icon}
		/>
	);
	
	const floorChartAndIconContainer = {
		display:"flex",
		justifyContent:"space-between",
		height:"60px",
		alignItems:"center",
		width:"calc(100% - 60px)",
		marginLeft:"40px",
		marginRight:"20px"
	};
	
	const floorChartContainer = {
		display:"flex",
		width:"calc(100% - 200px)",
		height:"10px",
		backgroundColor:"lightgrey",
		borderRadius:"10px",
		alignItems:"center",
		padding:"5px"
	};
	
	const floorChartBarElement = {
		display:"flex",
		height:"10px",
		minWidth:"10px"		
	};
	
	const iconContainer = {
		display:'flex',
		marginRight:"20px"
	};
	
	const getWidth = (area) => {
		if(area < 2){
			return '10px';
		}
		else{
			return area + '%';
		}
	} 
	
	const spaceTypeChartDisplay = spaceTypes.map((item, index) => 
		<FloorRowSpaceTypePercentage
			spaceTypeId={item.id}
			floorId={floorId}
			area={item.area}
			width={getWidth(item.areaPercentage)}
			color={item.color}
			floorName={name}
			name={item.name}
			isFirst={item.isFirst}
			isLast={item.isLast}
		/>
	);
	
	const populateRooms = (input) => {
		let tempRooms = [];
		for(let i=0; i<input.length; i++){
			tempRooms.push({
				id:input[i].id,
				code:input[i].code,
				name:input[i].name,
				description:input[i].description,
				areaReportable:functions.formatNumber(input[i].areaReportable, 0),
				capacity:input[i].capacity,
				spaceTypeId:input[i].spaceTypeId,
				spaceTypeName:input[i].spaceTypeName,
				classificationItemId:input[i].classificationItemId,
				classificationItemName:input[i].classificationItemName
			});
		}
		setRooms(tempRooms);
	};
	
	const roomTableContainer = {
		display:'flex',
		width:"100%",
		overflow:"auto",
		height:"70vh"
	}
	
	const roomTable = {
		display:"flex",
		width:"calc(100% - 80px)",
		marginLeft:"40px",
		marginTop:"20px",
		flexDirection:"column"
	};
	
	const roomTableHeader = {
		display:"flex",
		width:"100%",
		minHeight:"30px",
		backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		alignItems:"center"
	};
	
	const roomTableHeaderColumn = {
		display:"flex",
		color:"white",
		alignItems:"center",
		justifyContent:"space-around",
		fontSize:"14px"
	};
	
	
	const roomRow = {
		display:"flex",
		display:"flex",
		minHeight:"30px",
		borderBottom:"1px solid lightgrey",
		borderLeft:"1px solid lightgrey",
		alignItems:"center"
	};
	
	const roomRowColumn = {
		display:"flex",
		color:"black",
		fontSize:'12px',
		borderRight:"1px solid lightgrey",
		paddingLeft:"10px",
		height:"100%",
		alignItems:"center",
		overflow:"hidden"
	};
	
	const roomRowColumnNumeric = {
		display:"flex",
		flexDirection:"row-reverse",
		color:"black",
		fontSize:'12px',
		borderRight:"1px solid lightgrey",
		paddingRight:"10px",
		height:"100%",
		alignItems:"center",
		overflow:"hidden"
	};
	
	const roomRowColorIndicator = {
		display:'flex',
		height:"100%",
		minWidth:"10px",
		marginRight:"10px"
	}
	
	const roomDisplay = rooms.map((item, index) => 
		<div style={roomRow}>
			<div style={{...roomRowColumn, width:'100px'}}>
				{item.name}			
			</div>
			<div style={{...roomRowColumn, width:'calc(100% - 500px)'}}>
				{item.description}			
			</div>
			<div style={{...roomRowColumnNumeric, width:'100px'}}>
				{item.areaReportable}			
			</div>
			<div style={{...roomRowColumnNumeric, width:'100px'}}>
				{item.capacity}			
			</div>
			<div style={{...roomRowColumn, width:'200px', paddingLeft:'0px'}}>
				<div style={{...roomRowColorIndicator, backgroundColor:getColorForSpaceType(item.spaceTypeId)}}/>
				{item.spaceTypeName}			
			</div>
			<div style={{...roomRowColumn, width:'200px', paddingLeft:'0px'}}>
			<div style={{...roomRowColorIndicator, backgroundColor:getColorForClassificationItem(item.classificationItemId)}}/>
				{item.classificationItemName}			
			</div>
		</div>
	);
	
	return (
		<div style={thisContainer} onMouseOver={handleMouseOver} ref={thisRef}>
			<div style={popUp}  onMouseLeave={handleMouseLeave}>
				<div style={popUpLabel}>
					{name}: {area} SQM
				</div>
				<FontAwesomeIcon icon="info-circle" style={popUpIcon} onClick={handleClick}/>
			</div>
			<CSSTransition
				    in={displaySlider}
				    classNames="floorrowpercentageslider"
				    timeout={1000}
				    appear={false}
			>
				<div className="floorrowpercentageslider">
					<div style={roomListHeader}>
						<div style={roomListTitle}>
							{floorName} / {name}: Room List
						</div>
						<div style={closeArrowHolder}>
							<FontAwesomeIcon icon="times" style={closeArrowIcon} onClick={handleClose}/>
						</div>
					</div>
					<div style={floorChartAndIconContainer}>
						<div style={floorChartContainer}>
								{spaceTypeChartDisplay}
						</div>
						<div style={iconContainer}>
							{buttonDisplay}
						</div>
					</div>
					<div style={roomTableContainer}>
						<div style={roomTable}>
							<div style={roomTableHeader}>
								<div style={{...roomTableHeaderColumn, width:'100px'}}>
									Room
								</div>
								<div style={{...roomTableHeaderColumn, width:"calc(100% - 500px)"}}>
									Description
								</div>
								<div style={{...roomTableHeaderColumn, width:'100px'}}>
									Area
								</div>
								<div style={{...roomTableHeaderColumn, width:'100px'}}>
									Capacity
								</div>
								<div style={{...roomTableHeaderColumn, width:'200px'}}>
									Space Type
								</div>
								<div style={{...roomTableHeaderColumn, width:'200px'}}>
									CR Class
								</div>
							</div>
							{roomDisplay}
						</div>	
					</div>
				</div>
			</CSSTransition>
		</div>
	);
}